import { useState } from 'react'
import { useNavigate } from 'react-router'
import { Flex } from '@radix-ui/themes'
import { AxiosError } from 'axios'
import { PageHeading } from '@/components/subscription/page-heading'
import { FormLabel } from '@/components/subscription/form-label'
import { Button } from '@/components/subscription/button'
import { TextLink } from '@/components/subscription/text-link'
import { createClient } from '@/api-client'
import { Account } from '@/api-client/Account'
import { styles } from './styles.css'

export const SubscriptionMypagePassword: React.FC = () => {
  const navigate = useNavigate()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const [password, setPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const form = e.currentTarget
    if (!form.checkValidity()) {
      form.reportValidity()
      return
    }

    setIsSubmitting(true)
    setErrorMessage('')

    try {
      await createClient(Account).putAccount({ password, new_password: newPassword })

      await navigate('/subscription/mypage', { state: { message: 'パスワードを変更しました' } })
    } catch (error) {
      setErrorMessage(error.response?.data?.error?.message_displayable || 'パスワードの変更に失敗しました')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Flex direction="column" align="center" gap="40px" width="100%">
      <PageHeading>パスワード変更</PageHeading>

      <form onSubmit={handleSubmit} className={styles.form}>
        <Flex direction="column" align="center" gap="32px" width="100%">
          <Flex direction="column" gap="8px" width="100%">
            <div>
              <FormLabel htmlFor="current_password">現在のパスワード</FormLabel>
              <input
                type="password"
                id="current_password"
                name="current_password"
                className={styles.input}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={isSubmitting}
                autoComplete="current-password"
                required
              />
            </div>
            <div>
              <FormLabel htmlFor="password">新しいパスワード</FormLabel>
              <input
                type="password"
                id="password"
                name="password"
                className={styles.input}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                disabled={isSubmitting}
                autoComplete="new-password"
                required
                minLength={8}
              />
            </div>
          </Flex>
          <Flex direction="column" align="center" gap="32px" width="100%">
            <Flex direction="column" align="center" gap="16px" width="100%">
              <Button as="button" type="submit" size="m" fluid disabled={isSubmitting}>
                パスワードを変更する
              </Button>
              {errorMessage && <p className={styles.error}>{errorMessage}</p>}
            </Flex>
            <TextLink to="/subscription/mypage">マイページに戻る</TextLink>
          </Flex>
        </Flex>
      </form>
    </Flex>
  )
}
